import React from 'react'
// { useState , useEffect}
import { motion } from 'framer-motion';
import './About.scss';
import { AppWrap } from '../../wrapper';
import { images } from '../../constants';
// import { client, urlFor } from '../../client';

const abouts = [
  { title: 'Mobile App Developer', description: 'I am a mobile app developer with passion for build beautiful and functional mobile applications.', imgUrl: images.about01},
  { title: 'Frontend Developer', description: 'I am a good frontend developer with a passion for building beautiful web applications.', imgUrl: images.about02},
  { title: 'Backend Developer', description: 'I am a backend developer with a passion for building backend applications.', imgUrl: images.about03},
  { title: 'Web Designer', description: 'I am an good web designer with a creating beautiful web applications.', imgUrl: images.about04},
];

const About = () => {

  // const [abouts, setAbouts] = useState([]);

  // useEffect(() => {
  //   const query = '*[_type == "abouts"]';

  //   client.fetch(query)
  //     .then((data) =>  setAbouts(data))
  // },[])

  return (
    <>
     {/* <div className="tag-cmp app__flex">
        <p className="p-text">I am Rajeesh Upendran, Married, Living in Bangalore, India.<br />I am working as a Senior Architect at Hitachi Vantara Software Services India Pvt Ltd , Bangalore.</p>
        <p className="p-text">I have done my Masters Degree in Computer Application at University of Calicut.</p>
      </div> */}
      <h2 className="head-text">
        I Know That <span>Good Design</span> <br /> meant <span>Good Business</span>
      </h2>

      <div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.div 
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: 'tween' }}
            className="app__profile-item"
            key={about.title + index}
          >
            {/* <img src={urlFor(about.imgUrl)} alt={about.title} /> */}
            <img src={about.imgUrl} alt={about.title} />
            <h2 className="bold-text" style={{marginTop: 20}}>{about.title}</h2>
            <p className="p-text" style={{marginTop: 10}}>{about.description}</p>
          </motion.div>
        ))}
      </div>
    </>
  )
}

export default AppWrap(About, 'about')

